<div class="d-inline"><pux-translate tag="span" text="_LBL_SITZUNG_MODULE_PREVIEW_BERATUNGSVORLAGE_"></pux-translate></div>